// extracted by mini-css-extract-plugin
module.exports = {"FinishedQuiz":"FinishedQuiz_FinishedQuiz__2tHLQ","success":"FinishedQuiz_success__1hme5","error":"FinishedQuiz_error__1H-QX"};